module.exports = __webpack_public_path__ + "img/zona-nocturna.313fda8b.svg";